<template>
    <transition name="toggleContentComponent">
        <article class="fullscreenVideo" v-if="ready" :class="{ 'fullscreenVideo--videopaused': isVideoPaused }">
            <video ref="video" v-if="properties.video.src" :autoplay="properties.autoplay"
                :controls="properties.controls" :muted="properties.mute" :loop="properties.loop" :poster="posterUrl"
                @playing="isVideoPaused = false" @pause="isVideoPaused = true;" type="video/mp4" playsinline
                webkit-playsinline crossorigin>
                <source :src="videoUrl">
            </video>

            <button class="fullscreenVideo__close" @click="closeComponent"></button>
        </article>
    </transition>
</template>

<script>


export default {
    props: [
        "properties",
        "pageData",
        "slug"
    ],
    data() {
        return {
            ready: false,
            isVideoPaused: true,
            mutedAudioManager: false
        }
    },
    mounted() {
        this.ready = true;
        this.muteAudioManager();
    },
    methods: {
        muteAudioManager() {
            if (!this.$store.getters.getIsMuted) {
                this.mutedAudioManager = true;
                let event = new CustomEvent('muteAudio');
                window.dispatchEvent(event);
            }
        },
        unmuteAudioManager() {
            if (this.mutedAudioManager) {
                let event = new CustomEvent('unmuteAudio');
                window.dispatchEvent(event);
            }
        },
        closeComponent() {
            this.$emit("closeComponent", this.slug)
        }
    },
    unmounted() {
        this.unmuteAudioManager();
    },
    computed: {
        videoUrl() {
            return app.api.Utils.getMediaPath(this.properties.video.src)
        },
        posterUrl() {
            return app.api.Utils.getMediaPath(this.properties.poster.src)
        }
    }
};
</script>

<style lang="scss">
.fullscreenVideo {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 800px;
    margin-top: 32px;

    &>video,
    &>iframe {
        height: 100%;
    }

    iframe {
        aspect-ratio: 16 / 9;
    }

    &::after {
        display: none;
        content: url(@/assets/img/ui/play.svg);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        width: auto;
        height: 180px;
        pointer-events: none;
        z-index: 3;
    }

    &--videopaused {
        video {
            cursor: pointer;
        }

        &::after {
            display: block;
        }
    }
}


.fullscreenVideo__close {
    position: absolute;
    left: 100%;
    top: 0;
    height: 60px;
    width: 60px;
    border-radius: 50%;
    background: var(--main-color);
    background-image: url(@/assets/img/ui/close.svg);
    background-position: center;
    background-repeat: no-repeat;

    transition: transform .2s ease-in-out;

    &:hover {
        transform: scale(1.1);
    }
}
</style>